module.exports = __webpack_public_path__ + "static/media/fractal1.21f43d73.gif";